import requester from '@/lib/axios';
import {
  DNDOrdenationQuestion,
  OrderingQuestionCreateDTO,
} from '@/models/Question';

const baseUrl = 'dnd-ordenation-activity';

export const getOrderingQuestion = async (id: number) => {
  const { data } = await requester().get<DNDOrdenationQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createOrderingQuestion = async (
  body: Partial<OrderingQuestionCreateDTO>,
) => {
  const { data } = await requester().post<DNDOrdenationQuestion>(
    `${baseUrl}/`,
    body,
  );
  return data;
};

export const updateOrderingQuestion = async (
  id: number,
  changes: Partial<
    Pick<OrderingQuestionCreateDTO, 'title' | 'context' | 'feedbacks'>
  >,
) => {
  const { data } = await requester().patch<DNDOrdenationQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );
  return data;
};

export const deleteOrderingQuestion = async (id: number) => {
  await requester().delete(`${baseUrl}/${id}/`);
};
